import { RootState } from "@/store/dtm";
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface coapplicant {
    id: string,
    applicantId: number,
    firstName: string,
    lastName: string,
    dob_day: string,
    dob_month: string,
    dob_year: string,
    phoneNumber: string,
    relationship: string,
    email: string,
    inviteCode: string,
    isInviteActive: boolean
}

export interface coapplicantState {
    coapplicants: coapplicant[]
}

const initialState: coapplicantState = {
    coapplicants: []
}


export const coApplicantSlice = createSlice({
    name: "coapplicant",
    initialState,
    reducers: {
        addCoApplicant: (state, action: PayloadAction<coapplicant>) => {
            const coapplicant = action.payload;
            state.coapplicants.push(coapplicant);
        },
        setCoapplicantInfo: (state, action: PayloadAction<coapplicant>) => {
            const info = action.payload;
            state.coapplicants = state.coapplicants.map(app => app.id == info.id ? info : app);
        },
        setCoapplicantList: (state, action: PayloadAction<coapplicant[]>) => {
            const list = action.payload;
            state.coapplicants = list;
        },
        removeCoapplicant: (state, action: PayloadAction<string>) => {
            const id = action.payload;
            state.coapplicants = state.coapplicants.filter(coapplicant => coapplicant.id != id);
        },
        removeCoapplicantByInviteCode: (state, action: PayloadAction<string>) => {
            const code = action.payload;
            state.coapplicants = state.coapplicants.filter(coapplicant => coapplicant.inviteCode != code);
        },
        clearCoApplicantState: (state) => {
            state.coapplicants = []
        }
    }
});

export const { addCoApplicant, setCoapplicantInfo, removeCoapplicant, setCoapplicantList, clearCoApplicantState } = coApplicantSlice.actions

export default coApplicantSlice.reducer

export const selectCoApplicant = (state: RootState) => state.coApplicants;